export const func_format_data_list_reason = (list_reasons = []) => {
    return list_reasons.map((list) => ({
        id: list.id,
        key: list.id,
        header: list.name,
    }));
};
export const onSubmit = (data, files = [], mutate, id_user) => {
    mutate({
        id_user,
        body: {
            reason: data.reason?.id,
            reason_description: data.reason_description,
            temp_doc_ids: files
                .filter((file) => !file?.is_default)
                .map((file) => file?.id),
            existing_doc_ids: files
                .filter((file) => file?.is_default)
                .map((file) => file?.id),
        },
    });
    return;
};
